module.exports = __webpack_public_path__ + "img/Differentiation-CRC_10X_WTA.85c450b9.png";